export type Translation = {
  key: string
  translations: {
    [key in Options]: string
  }
}

export enum Options {
  fi = 'fi'
}

export type TranslationLanguages = 'fi'

export type TranslationKeys =
  | 'customer'
  | 'customers'
  | 'employee'
  | 'employees'
  | 'log_out'
  | 'cookieConsentPromptButtonText'
  | 'cookieConsentPromptBodyText'

export const values: Translation[] = [
  {
    key: 'customer',
    translations: {
      fi: 'Asiakas'
    }
  },
  {
    key: 'customers',
    translations: {
      fi: 'Asiakkaat'
    }
  },
  {
    key: 'employee',
    translations: {
      fi: 'Työntekijä'
    }
  },
  {
    key: 'employees',
    translations: {
      fi: 'Henkilöstö'
    }
  },
  {
    key: 'log_out',
    translations: {
      fi: 'Kirjaudu Ulos'
    }
  },
  {
    key: 'cookieConsentPromptButtonText',
    translations: {
      fi: 'Hyväksy'
    }
  },
  {
    key: 'cookieConsentPromptBodyText',
    translations: {
      fi: 'Palvelu käyttää vain välttämättömiä evästeitä palvelun toiminnan mahdollistamiseksi. Kolmansilla osapuolilla ei ole oikeuksia käsitellä evästetietoja.'
    }
  }
]
